// extracted by mini-css-extract-plugin
export default {"gallery":"About_gallery__mjPC1","aboutContentWrapper":"About_aboutContentWrapper__dbScY"};